var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17664_5741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0.75H3.75C2.7558 0.751191 1.80267 1.14666 1.09966 1.84966C0.396661 2.55267 0.00119089 3.5058 0 4.5L0 10.5C0.00119089 11.4942 0.396661 12.4473 1.09966 13.1503C1.80267 13.8533 2.7558 14.2488 3.75 14.25H8.25V15.75H5.25C5.05109 15.75 4.86032 15.829 4.71967 15.9697C4.57902 16.1103 4.5 16.3011 4.5 16.5C4.5 16.6989 4.57902 16.8897 4.71967 17.0303C4.86032 17.171 5.05109 17.25 5.25 17.25H12.75C12.9489 17.25 13.1397 17.171 13.2803 17.0303C13.421 16.8897 13.5 16.6989 13.5 16.5C13.5 16.3011 13.421 16.1103 13.2803 15.9697C13.1397 15.829 12.9489 15.75 12.75 15.75H9.75V14.25H14.25C15.2442 14.2488 16.1973 13.8533 16.9003 13.1503C17.6033 12.4473 17.9988 11.4942 18 10.5V4.5C17.9988 3.5058 17.6033 2.55267 16.9003 1.84966C16.1973 1.14666 15.2442 0.751191 14.25 0.75V0.75ZM3.75 2.25H14.25C14.8467 2.25 15.419 2.48705 15.841 2.90901C16.2629 3.33097 16.5 3.90326 16.5 4.5V9.75H1.5V4.5C1.5 3.90326 1.73705 3.33097 2.15901 2.90901C2.58097 2.48705 3.15326 2.25 3.75 2.25V2.25ZM14.25 12.75H3.75C3.2863 12.7481 2.83453 12.6029 2.45648 12.3344C2.07842 12.0659 1.79256 11.6872 1.638 11.25H16.362C16.2074 11.6872 15.9216 12.0659 15.5435 12.3344C15.1655 12.6029 14.7137 12.7481 14.25 12.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17664_5741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIcon);
export default __webpack_public_path__ + "static/media/computer-icon.cd058f2a334ee512ab1db3ba1208fa0e.svg";
export { ForwardRef as ReactComponent };